import { FC } from 'react';

import { IMAGES_PATH } from '@telialt/assets/src/constants';

import {
    AppPromotionContainer,
    AppPromotionContent,
    AppPromotionDescription,
    AppPromotionSection,
    AppPromotionTitle,
    EmptyGap,
    QrCodeImage,
    StoreButtonLink,
    StoreButtonsWrapper,
} from './FooterAppPromotion.styles';
import { StoreBadge } from './StoreBadge';
import { FOOTER_APP_PROMOTION_TEST_IDS } from './test-ids';
import { useDevicePlatform } from './useDevicePlatform';
import { useFooterAppPromotionText } from './useFooterAppPromotionText';

export const FooterAppPromotion: FC = () => {
    const text = useFooterAppPromotionText();

    const platform = useDevicePlatform();
    if (!text) {
        return null;
    }

    const { title, description, qrCodeTitle, appStoreUrl, appStoreTitle, googlePlayUrl, googlePlayTitle } = text;
    const showAppStoreButton = platform !== 'android';
    const showGooglePlayButton = platform !== 'apple';

    return (
        <AppPromotionSection data-test={FOOTER_APP_PROMOTION_TEST_IDS.SECTION}>
            <AppPromotionContainer>
                <AppPromotionContent>
                    <AppPromotionTitle>{title}</AppPromotionTitle>
                    <AppPromotionDescription>{description}</AppPromotionDescription>
                </AppPromotionContent>

                <StoreButtonsWrapper>
                    {showAppStoreButton && (
                        <StoreButtonLink
                            href={appStoreUrl}
                            data-test={FOOTER_APP_PROMOTION_TEST_IDS.APP_STORE_BUTTON}
                            title={appStoreTitle}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <StoreBadge brand="Apple" />
                        </StoreButtonLink>
                    )}
                    {showGooglePlayButton && (
                        <StoreButtonLink
                            href={googlePlayUrl}
                            data-test={FOOTER_APP_PROMOTION_TEST_IDS.GOOGLE_PLAY_BUTTON}
                            title={googlePlayTitle}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <StoreBadge brand="Google" />
                        </StoreButtonLink>
                    )}
                </StoreButtonsWrapper>

                <QrCodeImage
                    src={`${IMAGES_PATH}/telia-app-download-qr.svg?v=${process.env.GIT_HASH}`}
                    alt={qrCodeTitle}
                    data-test={FOOTER_APP_PROMOTION_TEST_IDS.QR_CODE}
                />

                <EmptyGap />
            </AppPromotionContainer>
        </AppPromotionSection>
    );
};
